import classNames from 'classnames'

import { AIButtonText } from '../AIButtonText'

import * as styles from './AIButtonTextGrey.module.css'

function AIButtonTextGrey({
  className = styles.aiButtonTextGrey,
  isLoading,
  textClassName = styles.aiButtonTextGreyLabel,
  ...restProps
}) {
  return (
    <AIButtonText
      {...restProps}
      isGrey
      className={classNames(className, {
        [styles.loading]: isLoading,
      })}
      isLoading={isLoading}
      textClassName={textClassName}
    />
  )
}

export default AIButtonTextGrey
